var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDarkLeftArrow = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "7px",
    height: "12px",
    viewBox: "0 0 7 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Arrowleft/7x12/dark-",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.594129609,12 C0.436295689,12.0006917 0.284818042,11.9418159 0.173908243,11.8366637 C-0.0579694142,11.6192731 -0.0579694142,11.2670999 0.173908243,11.0497092 L5.56542766,6.00132212 L0.173908243,0.952934998 C-0.0579694142,0.735544361 -0.0579694142,0.383371172 0.173908243,0.165980535 C0.284345427,0.0598546899 0.435882591,0 0.594129609,0 C0.752376627,0 0.903913791,0.0598546899 1.01435098,0.165980535 L6.82609176,5.60784488 C7.05796941,5.82523552 7.05796941,6.17740871 6.82609176,6.39479935 L1.01435098,11.8366637 C0.903441176,11.9418159 0.751963529,12.0006917 0.594129609,12 L0.594129609,12 Z",
    id: "Arrowleft/12x20/dark",
    fill: "#484848",
    fillRule: "nonzero",
    transform: "translate(3.500000, 6.000000) rotate(-180.000000) translate(-3.500000, -6.000000) "
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDarkLeftArrow);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/dark_left_arrow.60062dfb51b8c8c060e58f01a669d7a6.svg";